import React, { useRef, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import VehicleSearch from "../vehiclehistory/vehicle-search";
import "bootstrap-icons/font/bootstrap-icons.css";
import { imageMap } from "../../utils/imageMap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import { fetchReports } from "../../redux/slices/reports";
import LastRunReport from "./LastRunReport";
import { Tooltip, Popover } from "bootstrap";

const MyReportTab = ({ currentUser, onEditClick, onBuybackRegister }) => {
  const { view } = useSelector((state) => state.authentication);
  const dispatch = useDispatch();
  const { partners } = useSelector((state) => state.report);

  const searchVinRef = useRef(null);
  const upgradePlansRef = useRef(null);
  const navigate = useNavigate();
  const scrollToSearchVin = () => {
    searchVinRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToupgradePlans = () => {
    upgradePlansRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    const tooltips = [...tooltipTriggerList].map((tooltipTriggerEl) => {
      return new Tooltip(tooltipTriggerEl);
    });

    return () => {
      tooltips.forEach((tooltip) => tooltip.dispose());
    };
  }, [view?.allReports]);

  useEffect(() => {
    const popoverTriggerList = document.querySelectorAll(
      '[data-bs-toggle="popover"]'
    );
    const popovers = [...popoverTriggerList].map((popoverTriggerEl) => {
      return new Popover(popoverTriggerEl);
    });

    return () => {
      popovers.forEach((popover) => popover.dispose());
    };
  }, [view?.allReports]);
  
  const goToVehicleReport = async (vin, isOwner) => {
    navigate(`/vehiclehistory/full-vehicle-report/${vin}/${isOwner}`);
    window.scrollTo(0, 0);
    await dispatch(
      fetchReports({
        condition: "getFullReport",
        payload: { vin: vin, isOwner: isOwner, fileType: "HTML" },
      })
    );
  };

  const goToVehicleReportForActivate = async (vin, isOwner) => {
    if(view?.active === false || view?.reportsAvailable === 0){
      window.location.href = "/vehiclehistory/vehicle-history-reports";
      return;
    }
    navigate(`/vehiclehistory/full-vehicle-report/${vin}/${isOwner}`);
    window.scrollTo(0, 0);
    await dispatch(
      fetchReports({
        condition: "getFullReport",
        payload: { vin: vin, isOwner: isOwner, fileType: "HTML" },
      })
    );
  };

  const handleOwnerShip = async (vin, isOwner) => {
    if (isOwner) {
      navigate("/vehiclehistory/my-vehicle-offers");
    } else {
      navigate("/vehiclehistory/preferences-updated");
    }
    await dispatch(
      fetchReports({
        condition: "getFullReport",
        payload: { vin: vin, isOwner: isOwner, fileType: "HTML" },
      })
    );
  };
  const renderTableHeader = () => (
    <tr className="dashboard">
      <th style={{ width: "80px" }}>
        I Own
        <i
          className="bi bi-question-circle-fill questionPopoverIcon"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          data-bs-custom-class="custom-tooltip"
          title="Click the box to indicate you own this vehicle."
        ></i>
      </th>
      <th>Vehicle</th>
      <th style={{ width: "120px", whiteSpace: "nowrap" }}>
        AutoCheck Score™
        <i
          className="bi bi-question-circle-fill questionPopoverIcon ml-1"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          data-bs-html="true"
          data-bs-custom-class="custom-tooltip"
          title={`Use the patented AutoCheck Score™ to assess a vehicle's predicted reliability at a glance and compare it to similar cars in its class. <a href="autocheck-score">Learn more about the Score »</a>`}
        ></i>
      </th>
      <th style={{ width: "60px" }}></th>
      <th style={{ width: "160px", whiteSpace: "nowrap" }}>
        Buyback Protection
        <i
          className="bi bi-question-circle-fill questionPopoverIcon ml-1"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          data-bs-custom-class="custom-tooltip"
          title="Register qualified vehicles within 90 days of vehicle purchase to activate Buyback Protection. See Buyback Terms and Conditions for details »"
        ></i>
      </th>
      <th style={{ width: "110px", whiteSpace: "nowrap" }}>
        Run Date
        <i
          className="bi bi-question-circle-fill questionPopoverIcon ml-1"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          data-bs-custom-class="custom-tooltip"
          title="Please note that vehicle history data reflects events reported to Experian Automotive as of the displayed run date. Report data changes over time as the reported condition of the vehicle changes. Please run a fresh report to receive the most recently reported data."
        ></i>
      </th>
      <th style={{ width: "120px", whiteSpace: "nowrap" }}>
        Accessible Until
        <i
          className="bi bi-question-circle-fill questionPopoverIcon ml-1"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          data-bs-custom-class="custom-tooltip"
          title="Select “Activate Report” to renew your subscription and gain access to vehicle history reports that are no longer accessible."
        ></i>
      </th>
      <th style={{ width: "100px", textAlign: "center" }}></th>
    </tr>
  );

  const handleAddToCart = (item) => {
    if (localStorage.getItem("consumerSite_token")) {
      navigate("/vehiclehistory/checkout", {
        state: {
          selectedItem: item,
        },
      });
    }
  };

  const handleBuybackRegistration = () => {
    if (onBuybackRegister) {
      onBuybackRegister();
    }
  };

  const renderPartnerCard = (item, isLast, key, totalItems) => (
    <div className="cardContainer productPanel" key={key}>
      <div className="row">
        <div className="col-md-4 col-12">
          <img
            alt="AutoCheck Vehicle History Report"
            src={imageMap[item?.image]}
          />
        </div>
        <div className="col-md-8 col-12 productDescription">
          <div>
            {item?.htmlDescription && (
              <div
                dangerouslySetInnerHTML={{
                  __html: item.htmlDescription,
                }}
              />
            )}

            {item?.code !== "10300" && (
              <>
                <span className="price">$ {item?.price}</span>
                <button
                  type="button"
                  className="btn btn-primary base-button buttonPrimary"
                  onClick={() => handleAddToCart(item)}
                >
                  <span>Add to Cart</span>
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  const renderAccountDetails = () => (
    <div className="col-md-3 col-12 vehicle-dashboard_accountDetails">
      <p>
        <strong>Account Details</strong>
      </p>
      <p>
        {currentUser?.firstName} {currentUser?.lastName}
      </p>
      <p>{currentUser?.email}</p>
      <span className="clickLink linkstyle p-0 fw-normal" onClick={onEditClick}>
        Edit
      </span>
    </div>
  );

  const renderSubscriptionBanner = () => (
    <div className="col-md-9 col-12">
      <div className="d-flex flex-row p-3">
        <img
          src={require("../../assets/images/car_grebg.jpg")}
          alt="car garrage"
          className="vehicle-dashboard_carImg m-3"
        />
        <div>
          <h4>
            Renew your subscription now to restore access to your AutoCheck
            vehicle history reports.
          </h4>
          <Link
            to="/vehiclehistory/vehicle-history-reports"
            className="linkstyle"
          >
            See all subscription option »
          </Link>
        </div>
      </div>
    </div>
  );
  const renderViewReportsStatusBanner = () => (
    <div className="col-md-9 col-12">
      <div className="d-flex flex-row p-3">
        <img
          alt="AutoCheck Vehicle History Report"
          src={require("../../assets/images/AutoCheckVHR-Unlimited.png")}
          className="vehicle-dashboard_carImgSubscription mr-3"
        />

        <div>
          <strong>
            Your AutoCheck subscription is active: Reports that you've run
            during this subscription term will be available for the next{" "}
            {view?.daysRemaining} days. You have access to run{" "}
            {view?.reportsAvailable} history reports until your subscription
            expires.
          </strong>
          <hr />
          <p>
            (
            <Link
              to="/vehiclehistory/terms-of-use"
              rel="noopener noreferrer"
              className="linkstyle"
            >
              Terms of Use
            </Link>
            )
          </p>
          <div className="p-0">
            Your subscription expires on{" "}
            {moment(view?.expirationDate).format("MMMM Do, YYYY")}
          </div>
          <Link onClick={scrollToupgradePlans} className="linkstyle m-0">
            Upgrade or extend your subscription now »
          </Link>
        </div>
      </div>
    </div>
  );

  const renderMarketingBanners = () => (
    <div className="row mb-4 mt-5">
      <div className="col-sm-12 d-inline-block text-center">
        <Link
          to="https://www.keysavvy.com/partners/autocheck?aaId=exp&buyOrSell=buy"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={require("../../assets/images/KeySavvy-AutoCheck-teamup-bnr.png")}
            alt="Buying or selling your vehicle private party?"
          />
        </Link>
      </div>
    </div>
  );

  return (
    <div className="p-3">
      {/* <h3 className="titleBlue">My Reports</h3> */}
    
      <div className="cardContainer">
        <div className="row">
          {view?.active === false || Object.keys(view).length === 0
            ? renderSubscriptionBanner()
            : renderViewReportsStatusBanner()}
          {renderAccountDetails()}
        </div>
      </div>
      <LastRunReport
        goToVehicleReport={goToVehicleReport}
        scrollToSearchVin={scrollToSearchVin}
      />
      <div className="d-flex flex-row justify-content-between vehicle-dashboard_tableHeading mb-3">
        <h3 className="titleBlue d-inline-block">Vehicle History Reports</h3>
        <div>
          <strong>
            You have run
            <span className="m-1">
              {(view?.allReports?.length > 0 && view?.allReports?.length) || 0}
            </span>
            vehicle history reports.
          </strong>
          <Link className="m-2 linkstyle" onClick={scrollToSearchVin}>
            Run more reports »
          </Link>
          <div className="d-md-none d-block">
            Swipe / Scroll to see more information »
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-sm vehicle-dashboard_table mb-5" style={{ tableLayout: "fixed", width: "100%", minWidth: "1000px" }}>
          <thead>{renderTableHeader()}</thead>
          <tbody>
            {view?.allReports?.length > 0 &&
              view?.allReports?.map((report, index) => (
                <tr key={index}>
                  <td style={{ textAlign: "center" }}>
                    <input
                      type="checkbox"
                      className="m-0"
                      disabled={!report.active && view.active}
                      checked={
                        !report.active && view.active ? false : report.isOwner
                      }
                      onChange={(e) =>
                        handleOwnerShip(report.vin, e.target.checked)
                      }
                    />
                  </td>
                  <td>
                    {report.active ? (
                      <span
                        className="p-0 clickLink fw-normal"
                        onClick={() =>
                          goToVehicleReport(report.vin, report.isOwner)
                        }
                        style={{ wordBreak: "break-word" }}
                      >
                        <p className="mb-0">{`${report.year} ${report.make} ${report.model}`}</p>
                        <p className="mb-0" style={{ wordBreak: "break-all" }}>VIN: {report.vin}</p>
                      </span>
                    ) : (
                      <span style={{ wordBreak: "break-word" }}>
                        <p className="mb-0">{`${report.year} ${report.make} ${report.model}`}</p>
                        <p className="mb-0" style={{ wordBreak: "break-all" }}>VIN: {report.vin}</p>
                      </span>
                    )}
                  </td>
                  <td className="reportScore">{report.score}</td>
                  <td>
                    <div className="d-flex">
                      {report.singleOwner && (
                        <span
                          className="car-owner buybackBadgeSmall"
                          data-bs-toggle="tooltip"
                          data-bs-placement="bottom"
                          title="Calculated Owners: One"
                        />
                      )}
                      {report.accidentRecord && (
                        <span
                          className="car-accident buybackBadgeSmall"
                          data-bs-toggle="tooltip"
                          data-bs-placement="bottom"
                          title="Accident Record Found"
                        />
                      )}
                    </div>
                  </td>
                  <td>
                    {report.buybackAssurance === "ONE_YEAR" && (
                      <>
                        <span
                          className="badge_small_1year buybackBadgeSmall"
                          data-bs-toggle="tooltip"
                          data-bs-placement="bottom"
                          title="Qualifies for Buyback Protection: Register Now"
                        />
                        <span
                          className="p-2 clickLink fw-normal"
                          onClick={handleBuybackRegistration}
                        >
                          Register
                        </span>
                      </>
                    )}
                    {report.buybackAssurance === "THREE_YEARS" && (
                      <>
                        <span
                          className="badge_small_3year buybackBadgeSmall"
                          data-bs-toggle="tooltip"
                          data-bs-placement="bottom"
                          title="Qualifies for Buyback Protection: Register Now"
                        />
                        <span
                          className="p-2 clickLink fw-normal"
                          onClick={() => view.selectTab(2)}
                        >
                          Register
                        </span>
                      </>
                    )}
                    {report.buybackAssurance === "NOT_ASSURED" && (
                      <span
                        className="badge_small_error buybackBadgeSmall"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="Does not Qualify for Buyback Protection"
                      />
                    )}
                  </td>
                  <td>
                    {report.active ? (
                      <span
                        className="p-0 clickLink fw-normal"
                        onClick={() =>
                          goToVehicleReport(report.vin, report.isOwner)
                        }
                      >
                        {moment(report?.searchDate).format("MM/DD/YYYY")}
                      </span>
                    ) : (
                      moment(report?.searchDate).format("MM/DD/YYYY")
                    )}
                  </td>
                  <td>
                    {report.active && (
                      <span
                        className="p-0 clickLink fw-normal"
                        onClick={() =>
                          goToVehicleReport(report.vin, report.isOwner)
                        }
                      >
                        {moment(view?.expirationDate).format("MM/DD/YYYY")}
                      </span>
                    )}
                  </td>
                  <td>
                    {report.active ? (
                      <span
                        className="p-0 clickLink fw-normal"
                        onClick={() =>
                          goToVehicleReport(report.vin, report.isOwner)
                        }
                      >
                        View Report
                      </span>
                    ) : !report.active && view.active ? (
                      <span
                        className="p-0 clickLink fw-normal"
                        onClick={() =>
                          goToVehicleReportForActivate(report.vin, report.isOwner)
                        }
                      >
                        Activate
                      </span>
                    ) : (
                      <Link
                        className="p-0 clickLink fw-normal"
                        onClick={() =>
                          goToVehicleReportForActivate(report.vin, report.isOwner)
                        }
                      >
                        Activate
                      </Link>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {renderMarketingBanners()}

      <div className="col-12 mb-2">
        <h4>Please Note</h4>
        <p>
          That the data shown above reflects events reported to Experian
          Automotive as of the displayed run date. Report data changes over time
          as the reported condition of the vehicle changes. Please run a fresh
          report to receive the most recently reported data.
        </p>
        <Link
          to="/vehiclehistory/car-advise"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={require("../../assets/images/AutoCheck_CarAdvise_Banner2.jpg")}
            className="w-100"
            alt="Car Advise Banner"
          />
        </Link>
      </div>
      <div ref={searchVinRef}>
        <VehicleSearch />
      </div>
      {view?.allReports?.length > 0 && (
        <div ref={upgradePlansRef} className="col-12">
          <strong
            style={{
              color: "rgb(0, 73, 144)",
              marginBottom: "20px",
              display: "block",
            }}
          >
            Would you like to upgrade your subscription?
          </strong>
          {partners && [...partners].sort((a, b) => {
            // Move 10300 to the end
            if (a.code === "10300") return 1;
            if (b.code === "10300") return -1;
            // Otherwise sort by priority (lower priority number comes first)
            return (a.priority || 0) - (b.priority || 0);
          }).map((item, index, sortedArray) =>
            renderPartnerCard(
              item,
              index === sortedArray.length - 1,
              item.id || index,
              sortedArray.length
            )
          )}
        </div>
      )}
    </div>
  );
};

export default MyReportTab;
